import React, { useEffect, useState } from "react";
import axios from "axios";

const LabourReportTable = ({ clientName }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchLabourData();
  }, []);

  const fetchLabourData = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        "https://irc.zentelex.com/api/labour/all-labour",
      );
      setData(res.data.data || []);
    } catch (error) {
      console.error("Error fetching labour data:", error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Convert LabourInbound rows into report rows based on your model
  const reportRows = data.flatMap((item) => {
    const rows = [];

    const pushRow = (particular, unit, qty, rate, total) => {
      if (Number(total) > 0) {
        rows.push({
          warehouse: item.warehouse,
          client: item.clientName,
          entry_type: item.entry_type,
          crdNo: item.crdNo,
          cddNo: item.cddNo,
          period: item.entryDate,
          commodity: item.product,
          cargo_type: item.cargo_type,
          particular,
          unit,
          quantity: qty,
          rate,
          amount: total,
          remarks: "",
        });
      }
    };

    // ✅ BAG LOADING
    pushRow(
      "Bag Loading Charges",
      "Per Bag",
      item.bags,
      item.bag_rate,
      item.bag_total,
    );

    // ✅ BULK LOADING LABOUR
    pushRow(
      "Bulk Loading Labour Charges",
      "Per Head",
      item.bulk_labours_loading,
      item.bulk_rate,
      item.bulk_total,
    );

    // ✅ BULK UNLOADING LABOUR
    pushRow(
      "Bulk Unloading Labour Charges",
      "Per Head",
      item.bulk_labours_unloading,
      item.bulk_rate,
      item.bulk_total,
    );

    // ✅ BULK CONTAINER CHARGES
    pushRow(
      "Bulk Container Charges",
      "Per Container",
      item.bulk_containers,
      item.bulk_rate,
      item.bulk_total,
    );

    // ✅ RESTACKING
    pushRow(
      "Restacking Charges",
      "Per Head",
      item.restacking_labours,
      item.restacking_rate,
      item.restacking_total,
    );

    // ✅ STITCHING
    pushRow(
      "Stitching Charges",
      "Per Head",
      item.stitching_labours,
      item.stitching_rate,
      item.stitching_total,
    );

    // ✅ SWEEPING
    pushRow(
      "Sweeping Charges",
      "Per Head",
      item.sweeping_labours,
      item.sweeping_rate,
      item.sweeping_total,
    );

    // ✅ OTHER CHARGES
    pushRow(
      "Other Labour Charges",
      "-",
      item.others,
      item.other_rate,
      item.other_total,
    );

    return rows;
  });

  const filteredRows = clientName
    ? reportRows.filter((row) => row.client === clientName)
    : reportRows;

  // ✅ Grand Total
  const grandTotal = filteredRows.reduce(
    (sum, row) => sum + Number(row.amount || 0),
    0,
  );

  useEffect(() => {
    sessionStorage.setItem("labourTotal", grandTotal.toFixed(2));
  }, [grandTotal]);

  return (
    <div style={{ padding: "20px" }}>
      <h3>Labour Charges Report</h3>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table
          border="1"
          width="100%"
          cellPadding="6"
          style={{ borderCollapse: "collapse" }}
        >
          <thead style={{ background: "#f2f2f2" }}>
            <tr>
              <th>Warehouse</th>
              <th>Client</th>
              <th>Type</th>
              <th>Particular</th>
              <th>Date</th>
              <th>Unit</th>
              <th>Commodity</th>
              <th>Quantity</th>
              <th>Rate (Rs)</th>
              <th>Amount (Rs)</th>
              <th>Remarks</th>
            </tr>
          </thead>

          <tbody>
            {filteredRows.map((row, index) => (
              <tr key={index}>
                <td>{row.warehouse}</td>
                <td>{row.client}</td>
                <td>{row.entry_type}</td>
                <td>{row.particular}</td>
                <td>{row.period}</td>
                <td>{row.unit}</td>
                <td>{row.commodity}</td>
                <td>{row.quantity}</td>
                <td>{Number(row.rate).toFixed(2)}</td>
                <td>{Number(row.amount).toFixed(2)}</td>
                <td>{row.remarks}</td>
              </tr>
            ))}

            {/* ✅ Grand Total Row */}
            <tr style={{ fontWeight: "bold", background: "#fafafa" }}>
              <td colSpan="9" align="right">
                Total
              </td>
              <td>{grandTotal.toFixed(2)}</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
};

export default LabourReportTable;
